// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          "Welcome": "Welcome",
          "AskBuddy": "Ask Buddy",
          "TypeMessage": "Type your message...",
          "Send": "Send",
          "ViewMemory": "View Memory",
          "HideMemory": "Hide Memory",
          "ScrollToChat": "Scroll to chat",
          "BuddyThinking": "Buddy is thinking...",
          "ExampleStudentQ1": "What is gravity?",
          "ExampleStudentQ2": "How can I remember better?",
          "ExampleStudentQ3": "Why do we need sleep?",
          "ExampleTeacherQ1": "How can I help a distracted student?",
          "ExampleTeacherQ2": "What’s a good way to teach focus?",
          "ExampleTeacherQ3": "How to handle classroom anxiety?",
          "ExampleParentQ1": "My child is anxious — what should I do?",
          "ExampleParentQ2": "How to build good study habits?",
          "ExampleParentQ3": "How to reduce screen time without stress?",
          "Ask": "Ask",
"BuddyThinking": "Buddy is thinking...",
"WhatIRemember": "What I remember:",
"Forget": "Forget",
"BuddyListening": "Buddy is listening to you...",
"MicEnglish": "Microphone for English",
"MicTamil": "Microphone for Tamil"

        }
      },
      ta: {
        translation: {
          "Welcome": "வரவேற்கிறேன்",
          "AskBuddy": "படிக்கு கேளுங்கள்",
          "TypeMessage": "உங்கள் செய்தியை টাইப் செய்யவும்...",
          "Send": "அனுப்பு",
          "ViewMemory": "நினைவுகளைப் பார்க்க",
          "HideMemory": "நினைவுகளை மறைக்கவும்",
          "ScrollToChat": "அரட்டைக்கு செல்லவும்",
          "BuddyThinking": "படி யோசிக்கிறது...",
          "ExampleStudentQ1": "புவியீர்ப்பு விசை என்றால் என்ன?",
          "ExampleStudentQ2": "நான் எப்படி சிறப்பாக நினைவில் வைத்துக்கொள்ளலாம்?",
          "ExampleStudentQ3": "நாம் ஏன் தூங்க வேண்டும்?",
          "ExampleTeacherQ1": "கவனத்தை சிதறவைக்கும் மாணவருக்கு நான் எப்படி உதவலாம்?",
          "ExampleTeacherQ2": "கவனத்தை கற்றுக்கொடுக்க நல்ல வழி என்ன?",
          "ExampleTeacherQ3": "வகுப்பறை பதட்டத்தை எப்படிச் சமாளிக்கலாம்?",
          "ExampleParentQ1": "என் குழந்தை பதட்டமாக இருக்கிறாள் — என்ன செய்ய வேண்டும்?",
          "ExampleParentQ2": "நல்ல படிப்பு பழக்கங்களை உருவாக்க எப்படி?",
          "ExampleParentQ3": "ஸ்கிரீன் நேரத்தை மன அழுத்தமில்லாமல் குறைக்க எப்படி?",
          "Ask": "கேள்",
"BuddyThinking": "படி யோசிக்கிறது...",
"WhatIRemember": "நான் நினைவில் வைத்துள்ளவை:",
"Forget": "மறை",
"BuddyListening": "படி உங்களை கேட்கிறது...",
"MicEnglish": "ஆங்கில மைக்ரோஃபோன்",
"MicTamil": "தமிழ் மைக்ரோஃபோன்"

        }
      }
    },
    lng: localStorage.getItem('lng') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // You can add language detection plugins for advanced use
    },
  });

export default i18n;
